// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2g2t7","calendarButtons":"ClockData_calendarButtons__3nkGU"};